import React,{useState,useEffect} from 'react'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Form} from 'react-bootstrap'
import {AiOutlinePlus} from 'react-icons/ai'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import axios from 'axios';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import ReactPaginate from 'react-paginate';
import {optionsCampus, optionsClass, optionsShift, optionsSubject, optionsdocumentType, optionsevent, optionssection, optionssession, optionsteacherName, roledrp } from '../../Helper'
import moment from 'moment'
import { classSectionEntryApi } from '../../../utils/AdminDashApi/ClassSectionEntry'
import { TimePicker } from '@mui/x-date-pickers'
import { BsSearch } from 'react-icons/bs'
import { stuOtherInfoApi } from '../../../utils/AdminDashApi/StuOtherInfoApi'
import DocumentsSmBox from './subComponent/DocumentsSmBox'


const ViewDocumentComp = () => {

    const [session,setsession] = useState("")
    const [myclass,setclass] = useState("")
    const [section,setsection] = useState("")
    const [doctype,setdoctype] = useState("")
    const [datefrom,setdatefrom] = useState(null)
    const [datefromformat,setdatefromformat] = useState("")
    const [dateto,setdateto] = useState(null)
    const [datetoformat,setdatetoformat] = useState("")

    const drpfuncsession=(myval,myid)=>{
        setsession(myid)
    }
    const drpfuncclass=(myval,myid)=>{
        setclass(myid)
    }
    const drpfuncsection=(myval,myid)=>{
        setsection(myid)
    }
    const drpfuncdoctype=(myval,myid)=>{
        setdoctype(myid)
    }

    const handlesetdatefrom=(val)=>{
        setdatefrom(val)

        if(val != null){
      
            var dtmnt = val.$M + 1;
            var dtfinalc = val.$y + '-'+ dtmnt +'-'+ val.$D;
           
            setdatefromformat(dtfinalc)
        }
    }
    const handlesetdateto=(val)=>{
        setdateto(val)

        if(val != null){
      
            var dtmnt = val.$M + 1;
            var dtfinalc = val.$y + '-'+ dtmnt +'-'+ val.$D;
           
            setdatetoformat(dtfinalc)
        }
    }
  return (
    <>
          <div className="d-flex flexvaluecomp">

              <SidebarOfAdash />
              <div className="contentpartwidthwrapper">
                  <HeaderofAdash head="View Documents" />
                  <div className="contentofadmindash contentflexvalue">
                        <div className="w780 m-auto">
                            <Row>
                                <Col lg={4} className="pr7">
                                  <div className="basicinput">
                                      <p>Session</p>
                                      <div className="inputgap modalinputgap">
                                          <div className="dropdownwrapper">
                                              <Dropdown2  func={drpfuncsession} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionssession} />
                                          </div>
                                      </div>
                                  </div>
                                </Col>
                              <Col lg={4} className="pr7 pl7">
                                  <div className="basicinputfield h35p">
                                      <p>Class</p>
                                      <div className="inputgap">
                                          <div className="dropdownwrapper h40">
                                              <Dropdown2 err={false} func={drpfuncclass} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsClass} />
                                          </div>

                                      </div>
                                  </div>
                              </Col>
                              <Col className=" pl7">
                                  <div className="basicinput">
                                      <p>Section</p>
                                      <div className="inputgap modalinputgap">
                                          <div className="dropdownwrapper">
                                              <Dropdown2  func={drpfuncsection} myplaceholder=" " fontsize="16" fontfamily="'Poppins', sans-serif" options={optionssection} />
                                          </div>
                                      </div>
                                  </div>
                              </Col>
                              <Col lg={4} className="pr7">
                                  <div className="basicinput">
                                      <p>Document Type</p>
                                      <div className="inputgap modalinputgap">
                                          <div className="dropdownwrapper">
                                              <Dropdown2  func={drpfuncdoctype} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsdocumentType} />
                                          </div>
                                      </div>
                                  </div>
                                </Col>
                                <Col lg={4} className="pr7 pl7">
                                    <div className="basicinput">

                                        <p>From Date</p>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            value={datefrom}
                                            onChange={(newValue) => {
                                                handlesetdatefrom(newValue);
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                        </LocalizationProvider>
                                    </div>
                                    </Col>
                                <Col lg={4} className="pl7">
                                    <div className="basicinput">

                                        <p>To Date</p>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            value={datefrom}
                                            onChange={(newValue) => {
                                                handlesetdateto(newValue);
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                        </LocalizationProvider>
                                    </div>
                                    </Col>
                            </Row>

                        </div>
                        
                        <Row>
                                <Col lg={10} className="m-auto">
                                    <div className="basicinput">
                                        <p>Class 6</p>

                                        <div className="borderbox">
                                            <div className="wraprow">
                                        <h3 className='text-center'>Diamond 1</h3>
                                        <Row>
                                            <Col lg={4} className="pr7">
                                            <DocumentsSmBox/>

                                            </Col>
                                            <Col lg={4} className="pl7">
                                            <DocumentsSmBox/>

                                            </Col>
                                        </Row>

                                            </div>
                                            <div className="wraprow">
                                        <h3 className='text-center'>Diamond 2</h3>
                                        <Row>
                                            <Col lg={4} className="pr7">
                                            <DocumentsSmBox/>

                                            </Col>
                                            <Col lg={4} className="pl7">
                                            <DocumentsSmBox/>

                                            </Col>
                                        </Row>

                                            </div>
                                        </div>
                                    </div>
                                    

                                </Col>
                            </Row>
                  </div>
              </div>
          </div>
    </>
  )
}

export default ViewDocumentComp